const {Component} = require("react");
const PropTypes = require("prop-types");
const router = require("services/router");
const {classList} = require("helpers/html");

class Image extends Component {

	static get propTypes() {
		return {
			name: PropTypes.string.isRequired,
			value: PropTypes.string,
			placeholder: PropTypes.string,
			handleChange: PropTypes.func
		};
	}

	static get defaultProps() {
		return {
			placeholder: router.url("img/avatar-placeholder.png")
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			source: null,
			loading: false
		};
	}

	get source() {
		return this.state.source || this.props.value || this.props.placeholder;
	}

	handleChange = () => {
		if (typeof this.props.handleChange === "function") {
			this.props.handleChange(this.state.source);
		}
	};

	onFileChange = (e) => {
		if (e.target.files.length === 0) {
			this.setState(
				{loading: false, source: null},
				this.handleChange
			);
			return;
		}

		const file = e.target.files[0];

		this.setState({loading: true}, () => {
			const reader = new FileReader();

			reader.onload = () => this.setState(
				{source: reader.result, loading: false},
				this.handleChange
			);

			reader.onerror = () => this.setState(
				{loading: false, source: null},
				this.handleChange
			);

			reader.readAsDataURL(file);
		});
	};

	render() {
		return (
			<div className={classList("image-field", this.props.className, this.state.loading ? "loading" : false)}>
				<img src={this.source} alt={this.props.name}/>
				<label>
					<input type="file" accept="image/*" name={this.props.name} onChange={this.onFileChange}/>
				</label>
			</div>
		);
	}

}

module.exports = Image;


// WEBPACK FOOTER //
// ./resources/js/components/forms/Image.js